module.exports = __webpack_public_path__ + "static/media/add leave.a291c403.svg";